const AUDIO_VOLUME_SLIDER = "audio-volume-slider";
const AUDIO_CONTEXT_MENU = "audio-context-menu";
export {
  AUDIO_CONTEXT_MENU,
  AUDIO_VOLUME_SLIDER
};
//# sourceMappingURL=data-hooks.js.map
